import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
import contact_icon_1 from '../img/contact-icon-1.svg';
import contact_icon_2 from '../img/contact-icon-2.svg';
// import contact_icon_3 from '../img/contact-icon-3.svg';
import contact_banner from '../img/contact-banner-img.jpg';
import Client from "../contentful";
import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'
import { LightgalleryProvider } from "react-lightgallery";
import { LightgalleryItem } from "react-lightgallery";
import "../../node_modules/lightgallery.js/dist/css/lightgallery.css";
import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import { Player } from 'video-react';
import "../../node_modules/video-react/dist/video-react.css";
import "../../node_modules/bootstrap-hover-dropdown/bootstrap-hover-dropdown.min.js"

export default class Partneruniversitiessouthcarolina extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,

           banner:"",
           images:[],
           video:""
        }
        this.formatData = this.formatData.bind(this)
    }

    

    formatData(items) {
        let tempItems = items.map(item => {
          let id = item.sys.id;
          
          let banner = item.fields.banner?.fields?.file?.url
          let images =  item.fields.gallery;
          let video = item.fields.video
        
          this.setState({
              banner: banner,
              images: images,
              video:video
             
          })
        });
        return tempItems;
        console.log(items)
  
      }
      
      componentDidMount() {
          Client.getEntries({
              content_type : "partnerUniversitySouthCarolina"
            })
            .then(response=>{
              console.log(response.items)
              this.formatData(response.items)
              if( response.items[0].fields?.descriptionText){
              const descriptionText = response.items[0].fields?.descriptionText
              document.getElementById('rich-text-body').innerHTML = documentToHtmlString(descriptionText)

              }

              if( response.items[0].fields?.southCarolinaAtAGlanceText){
                const southCarolinaAtAGlanceText = response.items[0].fields?.southCarolinaAtAGlanceText
                document.getElementById('rich-text-body1').innerHTML = documentToHtmlString(southCarolinaAtAGlanceText)
                
                }
                if( response.items[0].fields?.universityOfSouthCarolinaLiveText){
                  const universityOfSouthCarolinaLiveText = response.items[0].fields?.universityOfSouthCarolinaLiveText
                  document.getElementById('rich-text-body2').innerHTML = documentToHtmlString(universityOfSouthCarolinaLiveText)
                  
                  }
                  if( response.items[0].fields?.uofScLiveBringsTheClassroomToYouText){
                    const uofScLiveBringsTheClassroomToYouText = response.items[0].fields?.uofScLiveBringsTheClassroomToYouText
                    document.getElementById('rich-text-body3').innerHTML = documentToHtmlString(uofScLiveBringsTheClassroomToYouText)
                    
                    }
                    if( response.items[0].fields?.mastersInInternationalBusinessMibText){
                      const mastersInInternationalBusinessMibText = response.items[0].fields?.mastersInInternationalBusinessMibText
                      document.getElementById('rich-text-body4').innerHTML = documentToHtmlString(mastersInInternationalBusinessMibText)
                      
                      }
                      if( response.items[0].fields?.whyChooseTheMibText){
                        const whyChooseTheMibText = response.items[0].fields?.whyChooseTheMibText
                        document.getElementById('rich-text-body5').innerHTML = documentToHtmlString(whyChooseTheMibText)
                        
                        }
                      

                          const graduateDegreeProgramsAtUOfScText = response.items[0].fields?.graduateDegreeProgramsAtUOfScText
                          document.getElementById('rich-text-body6').innerHTML = documentToHtmlString(graduateDegreeProgramsAtUOfScText)

                  
            })
  
            
  
      }
        

    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>
           
           <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem",marginRight:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>  
           

           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner carousel-slider">
    <div class="carousel-item active">	
      <img class="d-block w-100" src={this.state.banner} alt="First slide" />
      <div class="carousel-caption carousel-caption-center">
	    <h1>University of South Carolina</h1>
	  </div>
    </div>
  </div>
</div>

<div class="container mt-5 mb-5">


    <p><div id="rich-text-body"></div> </p>
</div>

<div class="container mt-5 mb-5">
  <h4 class="font-w-600 mt-5 mb-4">South Carolina at a Glance</h4>

  <p><div id="rich-text-body1"></div></p>

  <h4 class="font-w-600 mt-5 mb-4">Graduate Degree Programs at U of SC</h4>
  <p><div id="rich-text-body6"></div></p>




<div class="container">
  <div class="row">

  <div class="col-lg-12">  
    <div class="row">  
      <h2 class="mt-5 mb-3 font-w-600">University of South Carolina Live</h2>
      <p><div id="rich-text-body2"></div></p>
    </div>
    <hr/>
</div>

   <h4 class="mt-5 mb-3 font-w-600">UofSC Live brings the classroom to you</h4>

   {/* <p>Our innovative digital classroom experience uses cutting-edge technology to stream faculty-led courses live in real time. The classroom provides extensive interaction with leading international business faculty and fellow students forming an exceptional professional network to support your career and future success.</p> */}


    {/* <ul class="list-unstyled line-height-30">
        <p> <strong>Get a head start on your graduate education </strong> </p>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Enroll for Fall 2020 or Spring 2021—no study delays or interruptions.</li>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Earn credits toward a master’s degree in business while you work.</li>
    </ul> */}

    {/* <ul class="list-unstyled line-height-30">
        <p> <strong>Experience a digital classroom that rivals being there</strong> </p>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Learn from top-ranked UofSC faculty in a rigorous and collaborative environment.</li>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Engage with professors and classmates in real time and interact even more than in a traditional classroom.</li>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Get bilingual support for academic coursework with a local team </li>
    </ul> */}

    {/* <div class="col-lg-12">
      <div class="row">
    <ul class="list-unstyled line-height-30">
        <p> <strong>Enjoy a flexible and affordable program</strong> </p>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Stay on track by studying from your hometown.</li>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Take advantage of a late start.</li>
    </ul>
    </div>
  </div>   */}


    {/* <div class="col-lg-12">
      <div class="row">
    <ul class="list-unstyled line-height-30">
        <p> <strong>Benefit from additional support services</strong> </p>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Learn with English-language instruction tailored to your level.</li>
        <li><span class="mr-2"> <i class="fas fa-caret-right"></i> </span> Receive professional development assistance designed for business careers.</li>
    </ul>
    </div>
  </div>   */}


<p><div id="rich-text-body3"></div></p>

 </div>
</div>












<div class="container mb-5 pl-0 pr-0">
    <h2 class="mt-5 mb-3 font-w-600">Gallery</h2>
        <div class="home">
        <div class="aspire-campus">
            <ul class="lightgallery list-unstyled row">
            <LightgalleryProvider>
            {
					this.state.images.map(item => (

                <li class="col-xs-6 col-sm-4 col-md-3" >
                  <LightgalleryItem group="any" src={item?.fields?.file?.url}>
                    <a >
                        <img class="img-responsive pointer" src={item?.fields?.file?.url} />
                    </a>
                    </LightgalleryItem>
                </li>

                    ))

                    }
                {/* <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/usc/2.jpg">
                    <a href="">
                         <img class="img-responsive" src="img/partner-universities/usc/thumb-img-2.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/usc/3.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/usc/thumb-img-3.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/usc/4.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/usc/thumb-img-4.jpg" />
                    </a>
                </li> */}
                </LightgalleryProvider>
            </ul>
        </div>
      </div>

        

        

</div>


   <h4 class="font-w-600 mt-5">Masters in International Business (MIB)</h4>

   <br/>

   <div class="row">
     <div class="col-lg-12">
         <p><div id="rich-text-body4"></div></p>



  {/* <a  href="masters-international.php">
       <p class="list-inline-item color-2 mt-4"><i class="fas fa-arrow-right mr-1"></i><strong>Masters in International Business (MIB) </strong></p> 
    </a> */}


     </div>

     {/* <div class="col-lg-4"> <img src="img/mib.jpg" class="img-fluid m-t-55- mib-image" /> </div> */}
   </div>




   <div class="row">

     <div class="col-lg-10 usc">  
       
     
       
      <Player
      playsInline
      autoPlay

      src={this.state.video?.fields?.file?.url}
    />
    


     </div>


     <div class="col-lg-12">
       <h4 class="font-w-600 mt-3">Why choose the MIB?</h4>
       
   <p><div id="rich-text-body5"></div></p>
{/* 
    <a href="https://sc.edu/study/colleges_schools/moore/study/international_business/degree_programs/master_of_international_business/curriculum/index.php" target="_blank">Why choose the MIB</a> */}
     </div>

   </div>





</div>




            </div>
            
        )
    }
}